import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=35137048&scoped=true&"
import script from "./Offline.vue?vue&type=script&lang=ts&"
export * from "./Offline.vue?vue&type=script&lang=ts&"
import style0 from "./Offline.vue?vue&type=style&index=0&id=35137048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35137048",
  null
  
)

export default component.exports